import { createContext, useContext } from "react";

// True only inside the private-account interface; shared components use it to hide company, buyer and team wording.
export const PrivateAccountContext = createContext(false);

export const useIsPrivateAccount = () => useContext(PrivateAccountContext);
